import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Layout/Sidebar";
import Header from "../Layout/Header";
import "./ProjectDeploymentForm.css";
import ProjectTabs from "./ProjectTabs";

const professionalOptions = [
  { value: "1", label: "Professional 001" },
  { value: "2", label: "Professional 002" },
  { value: "3", label: "Professional 003" },
];

const assignmentOptions = [
  { value: "1", label: "Assignment 001" },
  { value: "2", label: "Assignment 002" },
];

const industryOptions = [
  { value: "1", label: "Oil & Gas" },
  { value: "2", label: "Manufacturing" },
  { value: "3", label: "Infrastructure" },
];

const scopeOptions = [
  { value: "1", label: "Inspection" },
  { value: "2", label: "Testing" },
  { value: "3", label: "Engineering" },
];

const authorityOptions = [
  { value: "1", label: "Observed" },
  { value: "2", label: "Performed" },
  { value: "3", label: "Reviewed" },
  { value: "4", label: "Independently Signed Off" },
];

const evidenceOptions = [
  { value: "1", label: "Inspection Certificate" },
  { value: "2", label: "Project Experience Document" },
  { value: "3", label: "Verification Report" },
];

const createScopeLink = () => ({
  experience_project_scope: "",
  industry: "",
  scope_catalog: "",
  authority_action_code: "",
  allocation_percent: "",
  verified_field_days: "",
  evidence_document: "",
});

const createPlacement = () => ({
  professional: "",
  professional_assignment: "",
  assigned_role: "",
  deployment_start: "",
  deployment_end: "",
  status: "ACTIVE",
  scope_links: [createScopeLink()],
});

const ProjectDeploymentForm = () => {
  const navigate = useNavigate();

  const [placements, setPlacements] = useState([createPlacement()]);

  const handlePlacementChange = (placementIndex, e) => {
    const { name, value } = e.target;

    setPlacements((prev) =>
      prev.map((placement, index) =>
        index === placementIndex
          ? {
              ...placement,
              [name]: value,
            }
          : placement
      )
    );
  };

  const handleScopeChange = (
    placementIndex,
    scopeIndex,
    e
  ) => {
    const { name, value } = e.target;

    setPlacements((prev) =>
      prev.map((placement, pIndex) => {
        if (pIndex !== placementIndex) {
          return placement;
        }

        return {
          ...placement,
          scope_links: placement.scope_links.map((scope, sIndex) =>
            sIndex === scopeIndex
              ? {
                  ...scope,
                  [name]: value,
                }
              : scope
          ),
        };
      })
    );
  };

  const addPlacement = () => {
    setPlacements((prev) => [...prev, createPlacement()]);
  };

  const removePlacement = (placementIndex) => {
    setPlacements((prev) =>
      prev.filter((_, index) => index !== placementIndex)
    );
  };

  const addScopeLink = (placementIndex) => {
    setPlacements((prev) =>
      prev.map((placement, index) =>
        index === placementIndex
          ? {
              ...placement,
              scope_links: [
                ...placement.scope_links,
                createScopeLink(),
              ],
            }
          : placement
      )
    );
  };

  const removeScopeLink = (placementIndex, scopeIndex) => {
    setPlacements((prev) =>
      prev.map((placement, index) => {
        if (index !== placementIndex) {
          return placement;
        }

        return {
          ...placement,
          scope_links: placement.scope_links.filter(
            (_, sIndex) => sIndex !== scopeIndex
          ),
        };
      })
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    for (let i = 0; i < placements.length; i++) {
      const placement = placements[i];

      if (
        placement.deployment_start &&
        placement.deployment_end &&
        placement.deployment_end < placement.deployment_start
      ) {
        alert(
          `Deployment end date cannot be before start date for Placement ${
            i + 1
          }.`
        );
        return;
      }

      for (let j = 0; j < placement.scope_links.length; j++) {
        const scope = placement.scope_links[j];

        if (
          scope.allocation_percent &&
          (Number(scope.allocation_percent) < 0 ||
            Number(scope.allocation_percent) > 100)
        ) {
          alert(
            `Allocation percentage must be between 0 and 100 for Placement ${
              i + 1
            }, Scope Link ${j + 1}.`
          );
          return;
        }
      }
    }

    console.log("Project Deployments:", placements);

    alert("Project deployments saved successfully.");
  };

  return (
    <div className="page-layout">
      <Sidebar />

      <div className="main-content">
        <Header />

        <div className="deployment-page-container">
          <ProjectTabs/>
          <div className="deployment-page-header">
            <div>
            

              <h1>Project Deployments</h1>

              <p>
                Manage professionals deployed to the project and their
                associated technical scope links.
              </p>
            </div>

              <button
                type="button"
                className="deployment-back-button"
                onClick={() => navigate("/admin/projects")}
              >
                ← Back
              </button>
          </div>

          <form
            className="deployment-form"
            onSubmit={handleSubmit}
          >
            {placements.map((placement, placementIndex) => (
              <div
                className="deployment-placement-card"
                key={placementIndex}
              >
                <div className="deployment-card-header">
                  <div className="deployment-card-title-wrapper">
                    <span className="deployment-number-badge">
                      {placementIndex + 1}
                    </span>

                    <div>
                      <h2>
                        Project Placement {placementIndex + 1}
                      </h2>

                      <p>
                        Define the professional deployment and
                        technical scope links.
                      </p>
                    </div>
                  </div>

                  {placements.length > 1 && (
                    <button
                      type="button"
                      className="deployment-remove-button"
                      onClick={() =>
                        removePlacement(placementIndex)
                      }
                    >
                      Remove Placement
                    </button>
                  )}
                </div>

                {/* Placement Information */}
                <div className="deployment-section">
                  <div className="deployment-section-title">
                    <h3>Placement Information</h3>

                    <p>
                      Define the professional and their project
                      assignment.
                    </p>
                  </div>

                  <div className="deployment-grid">
                    <div className="deployment-field">
                      <label>
                        Professional <span>*</span>
                      </label>

                      <select
                        name="professional"
                        value={placement.professional}
                        onChange={(e) =>
                          handlePlacementChange(
                            placementIndex,
                            e
                          )
                        }
                        required
                      >
                        <option value="">
                          Select professional
                        </option>

                        {professionalOptions.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                          >
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="deployment-field">
                      <label>
                        Professional Assignment
                      </label>

                      <select
                        name="professional_assignment"
                        value={
                          placement.professional_assignment
                        }
                        onChange={(e) =>
                          handlePlacementChange(
                            placementIndex,
                            e
                          )
                        }
                      >
                        <option value="">
                          Select assignment
                        </option>

                        {assignmentOptions.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                          >
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="deployment-field">
                      <label>
                        Assigned Role <span>*</span>
                      </label>

                      <input
                        type="text"
                        name="assigned_role"
                        value={placement.assigned_role}
                        onChange={(e) =>
                          handlePlacementChange(
                            placementIndex,
                            e
                          )
                        }
                        placeholder="e.g. Senior Inspector"
                        maxLength={120}
                        required
                      />
                    </div>

                    <div className="deployment-field">
                      <label>Status</label>

                      <select
                        name="status"
                        value={placement.status}
                        onChange={(e) =>
                          handlePlacementChange(
                            placementIndex,
                            e
                          )
                        }
                      >
                        <option value="ACTIVE">
                          Active
                        </option>
                        <option value="COMPLETED">
                          Completed
                        </option>
                        <option value="CANCELLED">
                          Cancelled
                        </option>
                        <option value="ON_HOLD">
                          On Hold
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Deployment Period */}
                <div className="deployment-section">
                  <div className="deployment-section-title">
                    <h3>Deployment Period</h3>

                    <p>
                      Specify the period for which the
                      professional is deployed.
                    </p>
                  </div>

                  <div className="deployment-grid">
                    <div className="deployment-field">
                      <label>
                        Deployment Start <span>*</span>
                      </label>

                      <input
                        type="date"
                        name="deployment_start"
                        value={
                          placement.deployment_start
                        }
                        onChange={(e) =>
                          handlePlacementChange(
                            placementIndex,
                            e
                          )
                        }
                        required
                      />
                    </div>

                    <div className="deployment-field">
                      <label>Deployment End</label>

                      <input
                        type="date"
                        name="deployment_end"
                        value={placement.deployment_end}
                        onChange={(e) =>
                          handlePlacementChange(
                            placementIndex,
                            e
                          )
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* Scope Links */}
                <div className="deployment-scope-section">
                  <div className="deployment-scope-header">
                    <div>
                      <h3>Scope Links</h3>

                      <p>
                        Add technical scope claims and
                        verified field experience for this
                        placement.
                      </p>
                    </div>

                    <button
                      type="button"
                      className="deployment-add-scope-button"
                      onClick={() =>
                        addScopeLink(placementIndex)
                      }
                    >
                      + Add Scope Link
                    </button>
                  </div>

                  {placement.scope_links.map(
                    (scope, scopeIndex) => (
                      <div
                        className="deployment-scope-card"
                        key={scopeIndex}
                      >
                        <div className="deployment-scope-card-header">
                          <div className="deployment-scope-title">
                            <span className="deployment-scope-number">
                              {scopeIndex + 1}
                            </span>

                            <div>
                              <h4>
                                Scope Link {scopeIndex + 1}
                              </h4>

                              <p>
                                Technical scope and
                                experience allocation
                              </p>
                            </div>
                          </div>

                          {placement.scope_links.length >
                            1 && (
                            <button
                              type="button"
                              className="deployment-remove-scope-button"
                              onClick={() =>
                                removeScopeLink(
                                  placementIndex,
                                  scopeIndex
                                )
                              }
                            >
                              Remove
                            </button>
                          )}
                        </div>

                        {/* Professional Scope */}
                        <div className="deployment-subsection">
                          <div className="deployment-subsection-title">
                            <h4>
                              Professional Scope
                            </h4>

                            <p>
                              Select the experience scope
                              associated with this claim.
                            </p>
                          </div>

                          <div className="deployment-grid">
                            <div className="deployment-field">
                              <label>
                                Experience Project Scope
                              </label>

                              <select
                                name="experience_project_scope"
                                value={
                                  scope.experience_project_scope
                                }
                                onChange={(e) =>
                                  handleScopeChange(
                                    placementIndex,
                                    scopeIndex,
                                    e
                                  )
                                }
                              >
                                <option value="">
                                  Select experience scope
                                </option>

                                <option value="1">
                                  Experience Scope 001
                                </option>

                                <option value="2">
                                  Experience Scope 002
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>

                        {/* Industry and Scope */}
                        <div className="deployment-subsection">
                          <div className="deployment-subsection-title">
                            <h4>
                              Industry & Scope
                            </h4>

                            <p>
                              Define the industry and
                              technical scope covered by
                              the claim.
                            </p>
                          </div>

                          <div className="deployment-grid">
                            <div className="deployment-field">
                              <label>
                                Industry <span>*</span>
                              </label>

                              <select
                                name="industry"
                                value={scope.industry}
                                onChange={(e) =>
                                  handleScopeChange(
                                    placementIndex,
                                    scopeIndex,
                                    e
                                  )
                                }
                                required
                              >
                                <option value="">
                                  Select industry
                                </option>

                                {industryOptions.map(
                                  (option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  )
                                )}
                              </select>
                            </div>

                            <div className="deployment-field">
                              <label>
                                Scope Catalog <span>*</span>
                              </label>

                              <select
                                name="scope_catalog"
                                value={scope.scope_catalog}
                                onChange={(e) =>
                                  handleScopeChange(
                                    placementIndex,
                                    scopeIndex,
                                    e
                                  )
                                }
                                required
                              >
                                <option value="">
                                  Select scope
                                </option>

                                {scopeOptions.map(
                                  (option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  )
                                )}
                              </select>
                            </div>

                            <div className="deployment-field">
                              <label>
                                Authority Action{" "}
                                <span>*</span>
                              </label>

                              <select
                                name="authority_action_code"
                                value={
                                  scope.authority_action_code
                                }
                                onChange={(e) =>
                                  handleScopeChange(
                                    placementIndex,
                                    scopeIndex,
                                    e
                                  )
                                }
                                required
                              >
                                <option value="">
                                  Select authority
                                </option>

                                {authorityOptions.map(
                                  (option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  )
                                )}
                              </select>
                            </div>
                          </div>
                        </div>

                        {/* Experience Allocation */}
                        <div className="deployment-subsection">
                          <div className="deployment-subsection-title">
                            <h4>
                              Experience Allocation
                            </h4>

                            <p>
                              Capture allocation and
                              verified field experience.
                            </p>
                          </div>

                          <div className="deployment-grid">
                            <div className="deployment-field">
                              <label>
                                Allocation (%){" "}
                                <span>*</span>
                              </label>

                              <input
                                type="number"
                                name="allocation_percent"
                                value={
                                  scope.allocation_percent
                                }
                                onChange={(e) =>
                                  handleScopeChange(
                                    placementIndex,
                                    scopeIndex,
                                    e
                                  )
                                }
                                min="0"
                                max="100"
                                placeholder="0 - 100"
                                required
                              />
                            </div>

                            <div className="deployment-field">
                              <label>
                                Verified Field Days
                              </label>

                              <input
                                type="number"
                                name="verified_field_days"
                                value={
                                  scope.verified_field_days
                                }
                                onChange={(e) =>
                                  handleScopeChange(
                                    placementIndex,
                                    scopeIndex,
                                    e
                                  )
                                }
                                min="0"
                                placeholder="Enter field days"
                              />
                            </div>

                            <div className="deployment-field">
                              <label>
                                Evidence Document
                              </label>

                              <select
                                name="evidence_document"
                                value={
                                  scope.evidence_document
                                }
                                onChange={(e) =>
                                  handleScopeChange(
                                    placementIndex,
                                    scopeIndex,
                                    e
                                  )
                                }
                              >
                                <option value="">
                                  Select document
                                </option>

                                {evidenceOptions.map(
                                  (option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  )
                                )}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  )}

                  <div className="deployment-evidence-box">
                    <span className="deployment-info-icon">
                      i
                    </span>

                    <div>
                      <strong>
                        Evidence & Verification
                      </strong>

                      <p>
                        Evidence documents are optional and
                        can be linked to support the
                        professional's technical scope
                        claim.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            <div className="deployment-add-placement-wrapper">
              <button
                type="button"
                className="deployment-add-placement-button"
                onClick={addPlacement}
              >
                + Add Another Placement
              </button>
            </div>

            <div className="deployment-association-box">
              <span className="deployment-info-icon">
                i
              </span>

              <div>
                <strong>Project Deployment</strong>

                <p>
                  Each placement is automatically associated
                  with the current project. Scope links are
                  maintained under their respective
                  placement.
                </p>
              </div>
            </div>

            <div className="deployment-form-actions">
              <button
                type="button"
                className="deployment-cancel-button"
                onClick={() => navigate("/admin/projects")}
              >
                Cancel
              </button>

              <button
                type="submit"
                className="deployment-save-button"
              >
                Save All Deployments
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ProjectDeploymentForm;